export default {
	ALGOLIA_APP_ID: 'CDS7UYZT3P',
	ALGOLIA_SEARCH_KEY: '42bc8b3b9c1817871aa3ed763cef5728'
};
